const ColorsClass = {
    primaryGreen: '#00A650',
    primaryRed: '#C60F0F',
    white: '#FFFFFF',
    yellow: '#FFE500',
    orange: '#c96835',
    white80: 'rgba(255,255,255,0.8)',
    black: '#000000',
    eventCard: '#7B9266',
    greyHomeCard: '#3C4042',
    greyHomeCardForeground: '#4c5254',
    greySkeletonForeground: '#545b5d',
    greySkeletonBackground: '#252528',
    chatbotBlue: '#007BA7',
    chatbotBlueHover: '#028ec3',
    chatbotBluePressed: '#035a7a',
};

const GradientsClass = {
    blackLanding: ['rgba(0,0,0,0.4)', 'rgba(0,0,0,0.9)', '#000000'],
    blackProductLanding: ['rgba(0,0,0,0)', 'rgba(0,0,0,1)', 'rgba(0,0,0,1)'],
    blackHome: ['#000000', '#1F2326'],
    // blackHome: ['#1F2326FF', '#1F2326'],
    blackOverlayCard: ['rgba(0,0,0,0.21)', '#000000'],
    categoryOverlayCard: ['rgba(0,0,0,0.3)', 'rgba(0,0,0,0.9)'],
    categoryOverlayCardH: ['rgba(0,0,0,0.05)', 'rgba(0,0,0,1)'],
};

export {ColorsClass, GradientsClass};
